import { useCallback } from "react";
import { proxy, useSnapshot } from "valtio";
import { BottomMenuPaths } from "../components/bottom-menu/paths";
import { useBottomMenu } from "./useBottomMenu";

const transformModeState = proxy({
	isTransformMode: false,
});

export function useIsTransformMode() {
	const { gotoPath, currentPath } = useBottomMenu();
	const { isTransformMode } = useSnapshot(transformModeState);

	const setIsTransformMode = useCallback(
		(enableTransform: boolean) => {
			transformModeState.isTransformMode = enableTransform;

			// Open the Transform Panel when mode is changed
			// Remark: Did not automatically closed the panel when transformMode is false,
			// because there is already logic to open the default menu when for example a zone is changed
			if (
				transformModeState.isTransformMode &&
				currentPath !== BottomMenuPaths.PhotoTransform
			) {
				gotoPath(BottomMenuPaths.PhotoTransform);
			}
		},
		[currentPath, gotoPath],
	);

	return [isTransformMode, setIsTransformMode] as const;
}
